export const isLocal = window.location.hostname === "localhost";